module.exports = __webpack_public_path__ + "img/21.885a4209.svg";